export const CHECKBOX_VARIANT = {
  info: "info",
  success: "success",
  warning: "warning",
  error: "error",
  default: "default",
} as const

export type CheckboxVariant = (typeof CHECKBOX_VARIANT)[keyof typeof CHECKBOX_VARIANT]

export const CHECKBOX_LABEL_FONT_SIZE = {
  xs: "xs",
  s: "s",
  m: "m",
  l: "l",
} as const

export type CheckboxLabelFontSize = (typeof CHECKBOX_LABEL_FONT_SIZE)[keyof typeof CHECKBOX_LABEL_FONT_SIZE]

export const CHECKBOX_LABEL_TEXT_COLOR = CHECKBOX_VARIANT

export type CheckboxLabelTextColor = (typeof CHECKBOX_LABEL_TEXT_COLOR)[keyof typeof CHECKBOX_LABEL_TEXT_COLOR]
